import axios from '@/api/requests/axios'

export default {
  getAll: params => axios.get('/api/admin/v1/customers', { params }),
  getCustomersDropdown: params => axios.get('api/admin/v1/customers/drop-down', { params }),
  resetSmsLimit: id => axios.put(`/api/admin/v1/customers/${id}/sms-limit/reset`, {}),
  getLoyalty: phoneNumber => axios.get('/api/admin/v1/customers/loyalty', { params: { phoneNumber } }),
}
